import { Component, Input, OnInit, signal } from '@angular/core';
import { Document } from '@app/modules/core/store/models';
import { getCountryCode, getLocationDisplayText } from '../horizon-ratings-utils';

@Component({
    selector: 'topo-ratings-location-display',
    templateUrl: './ratings-location-display.component.html',
    styleUrls: ['./ratings-location-display.component.scss'],
    standalone: false
})
export class RatingsLocationDisplayComponent implements OnInit {
  @Input() document: Document;

  countryCode = signal('xx');
  locationDisplayText: string[] = [];

  ngOnInit(): void {
    const { country_name, name, language_code, country_id } = this.document;

    this.locationDisplayText = getLocationDisplayText(name, country_name);
    this.loadCountryCodeForFlag(country_id, country_name, language_code);
  }

  private async loadCountryCodeForFlag(country_id: number, country_name: string, language_code: string): Promise<void> {
    try {
      const countryCode = await getCountryCode(country_id, country_name, language_code);
      this.countryCode.set(countryCode);
    } catch (e) {
      console.warn(e);
    }
  }
}
